
import axios, { AxiosResponse } from 'axios';
import { User, SalesPageUpdateRequests , UpdateRoleRequest , Lead} from './types';
import {  } from '../pages/SalesPage';


export enum Role {
    SUPERADMIN = 'SUPERADMIN',
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    TEAM_LEADER = 'TEAM_LEADER',
    AGENT = 'AGENT',
    USER = 'USER'
}
export interface MainUser {
    id: string;
    firstName: string;
    lastName?: string;
    email?: string;
    mobile?: string;
}

export interface OrderItem {
    id: number;
    productId: number;
    productName: string;
    quantity: number;
    payableAmount: number; 
    price: number;
    discountPercentage: number;
    unit: string;
}

// export interface Order {
//     id: number; 
//     orderId: string;
//     customerName: string;
//     email: string;
//     mobile: string;
//     alternateMobile: string;
//     houseNumber: string;
//     streetArea: string;
//     landmark: string;
//     city: string;
//     state: string;
//     pincode: string;
//     country: string;
//     categoryId: number | null; 
//     subCategoryId: number | null;
//     orderDate: string; 
//     remark: string;
//     sellerUsername: string; 
//     status: string;
//     items: OrderItem[]; 
// }

export interface Order {
    id: string; // Changed to string for UUID
    orderId?: string; // Optional display ID if needed
    
    // Customer Info (Relation from MainUser)
    mainUser?: MainUser;
    
    // Fallback fields agar backend flat bhej raha hai
    customerName?: string;
    email?: string;
    mobile?: string;
    alternateMobile?: string;
    
    // Address
    houseNumber?: string;
    streetArea?: string;
    landmark?: string;
    city?: string;
    state?: string;
    pincode?: string;
    country?: string;

    // Flat Product Fields (Sold.java structure)
    medicine: string;
    medicineUnit?: string;
    medicineQuantity: number;
    medicinePrice: number;
    
    // Payment Info
    discountPercentage?: number;
    discountAmount?: number;
    paidAmount?: number;
    payableAmount: number;
    
    // Meta
    status: string;
    sellerUsername?: string;
    createdAt?: string;
    remark?: string;
}

export interface Category {
  id: number;
  name: string;
  parentId: number | null;
}

export interface Product {
  id: number; 
  productName: string;
  measurementUnit: string;          // e.g., 'ml', 'gm'
  typeQuantity: number | string;    // e.g., 10, 200
  price: number;
}

export interface OrderItemRequest {
    id?: number | null; 
    productId: number;
    productName: string;
    unit: string;
    price: number;
    quantity: number;
    discountPercentage: number;
    payableAmount: number;
}

export interface SalesPageUpdateRequest { 
  name: string;
  email?: string;
  mobile?: string;
  alternateMobile: string; 
  
  // ✅ All missing fields added here
  remark: string;

  // Address
  houseNumber: string;
  streetArea: string;
  landmark: string;
  city: string;
  state: string;
  pincode: string;
  country: string;
  
  // ✅ Flat Product Details (Jo error de rahe the)
  medicine: string;
  medicineUnit: string;
  medicineQuantity: number;
  medicinePrice: number;
  
  discountPercentage: number;
  discountAmount: number;
  paidAmount: number;
  payableAmount: number;
  
  // Helpers
  categoryId?: number | null;
  subCategoryId?: number | null;
  
  // Empty array for compatibility
  orderItems?: any[]; 
}


const api = axios.create({
  // baseURL: 'http://localhost:8484/api', // Adjust this if your backend runs on a different port
  baseURL : 'https://ayushvatika.com/api'
});

// Add a request interceptor to include the JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);




export const getAllUsers = () => {
  return axios.get<User[]>('/api/admin/users/all');
};

export const login = (credentials: any) => {
  return api.post('/admin/users/login', credentials);
};

export const signup = (userData: any) => {
  return api.post('/admin/users/signup', userData);
};

export const getSubordinates = () => {
  return api.get('/admin/users/subordinates');
};

export const getUsersByRole = (role: string): Promise<AxiosResponse<any[]>> => {
    return api.get(`/admin/users/by-role?role=${role}`);
};

export const getPendingUsers = (): Promise<AxiosResponse<User[]>> => {
    return api.get(`/admin/users/pending-approvals`); 
};

// New function to get subordinates by parentId (for cascading dropdowns)
export const getSubordinatesByParentId = (parentId: number): Promise<AxiosResponse<any[]>> => {
    return api.get(`/admin/users/subordinates/by-parent?parentId=${parentId}`); 
};

export const updateRoleAndActivate = (userId: number, data: UpdateRoleRequest) => {
      return api.put(`/admin/users/${userId}/activate-role`, data);
};

export const getSubordinatesByParent = (parentId: number | null): Promise<AxiosResponse<User[]>> => {
    return api.get(`/admin/users/subordinates/by-parent`, { 
        params: { parentId } 
    });
};

export const getAllActiveUsers = () => {
    return api.get<User[]>('/admin/users/active-users');
};

// **<--- BAAKI SAB FUNCTIONS WAISE HI RAHENGE --->**
export const activateUser = (id: number) => {
  return api.put(`/admin/users/${id}/activate`);
};

export const deactivateUser = (id: number) => {
  return api.put(`/admin/users/${id}/deactivate`);
};

// export const getPendingUsers = () => {
//     return api.get<User[]>(`/admin/users/pending-approvals`);
// };

export const getEmployeeProfile = (userId: number) => {
  return api.get(`/admin/employees/${userId}/profile`);
};

export const saveOrUpdateEmployeeProfile = (userId: number, data: any) => {
  return api.post(`/admin/employees/${userId}/profile`, data);
};

export const createSaleOrder = (data: SalesPageUpdateRequests) => {
    return api.post('/admin/sale-orders', data);
};

export const updateLead = (id: number, data: any) => { 
  return api.put(`/admin/leads/${id}`, data);
}; 

export const fetchUnverifiedOrders = (): Promise<AxiosResponse<Order[]>> => {
    return api.get(`/admin/unverified-orders`);
};

// ✅ CORRECT URL for Verified Orders
export const fetchVerifiedOrders = (): Promise<AxiosResponse<Order[]>> => {
    return api.get(`/admin/verified-orders`);
};

// ✅ CORRECT URL for Verify & Delete
export const verifyOrder = (orderId: string) => {
    return api.put(`/admin/verify-order/${orderId}`);
};

export const deleteOrder = (orderId: string) => {
    return api.delete(`/admin/delete-order/${orderId}`);
};
export const fetchOrderById = (orderId: string): Promise<AxiosResponse<Order>> => {
    // return api.get(`/admin/sale-orders/${orderId}`);
    return api.get(`/admin/sold-order-details/${orderId}`);
};


export const updateSaleOrder = (orderId: string, data: SalesPageUpdateRequest) => {
    return api.put(`/admin/sale-orders/${orderId}`, data);
};


//----------------------------------------------------------

// 🔥 NEW: Fetch Categories (TS2305 fix)
export const fetchAllCategories = (): Promise<AxiosResponse<Category[]>> => {
    return api.get(`/categories`);
};

// 🔥 NEW: Fetch Products by Category (TS2305 fix)
export const fetchProductsByCategory = (categoryId: number): Promise<AxiosResponse<Product[]>> => {
    return api.get(`/products/category/${categoryId}`); 
};

export const assignLeads = (data: { leadIds: string[], assignToUserId: number }) => {
    return api.post('/admin/leads/assign', data);
};
export const fetchSubCategoriesWithCount = (parentId: number) => {
    return api.get(`/categories/subcategories-with-count/${parentId}`);
};

export const uploadFile = (file: File) => {
  const formData = new FormData();
  formData.append('file', file);
  return api.post('/uploads/file', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};